module.exports = __webpack_public_path__ + "img/honor_sg_002.0163bba.webp";